import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export function clientAssetsService() {
	const api = useApi()

	async function getDadosTempoVencimento(clienteId) {
		return api.query(
			`${window.location.origin}${URLS.grafico_tempo_vencimento}${clienteId}`
		)
	}

	async function getDetalhesVolatilidade(
		clienteId,
		periodo,
		data_inicio,
		data_fim
	) {
		return api.query(
			`${window.location.origin}${URLS.tabela_clientepf_volatilidade}?cliente=${clienteId}&periodo=${periodo}&data_inicio=${data_inicio}&data_fim=${data_fim}`
		)
	}

	async function getDetalhesRetorno(clienteId, quatidade_meses) {
		return api.query(
			`${window.location.origin}${URLS.tabela_clientepf_retorno}?cliente=${clienteId}&quantidade_meses=${quatidade_meses}`
		)
	}

	async function getInfoAtendimentoCliente(query = '', params = {}) {
		return api.query(
			`${window.location.origin}${URLS.informacoes_modal_cliente_pf}${query}`,
			params
		)
	}
	return {
		getDadosTempoVencimento,
		getDetalhesVolatilidade,
		getDetalhesRetorno,
		getInfoAtendimentoCliente,
		...api,
	}
}
